import React from 'react';
import { trans } from '../utils';

/**
 * Chat Trigger Button - Fixed position FAB to open/close chat
 */
const ChatTriggerButton = ({ isOpen, onClick, hasUnreadMessages }) => {
  return (
    <button
      className={`chat-trigger-button ${isOpen ? 'is-open' : ''}`}
      onClick={onClick}
      aria-label={isOpen ? trans('Close chat') : trans('Open chat')}
      aria-expanded={isOpen}
    >
      {isOpen ? (
        // Close icon
        <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      ) : (
        // Chat bubble icon
        <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
        </svg>
      )}
      {hasUnreadMessages && !isOpen && (
        <span className="chat-trigger-badge" aria-label={trans('New messages')}></span>
      )}
    </button>
  );
};

export default ChatTriggerButton;
